module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Triangle-38a85567a81f55c171045976e1dc39ed.svg";